<template lang="pug">
  .right
    el-button.btn-action(
      @click="retornarPaginaInicial"
    )
      i.fas.fa-chevron-left
      | &nbsp Voltar
</template>

<script>

export default {

  props: {
    titulo: {
      type: String,
      required: true
    },
    route: {
      type: String,
      default: 'central/home'
    }
  },

  methods: {
    retornarPaginaInicial () {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>

  .component {
    z-index: 2;
    .center {
      display: flex;
      align-items: center;
    }

    .text {
      color: #575757;
      padding: 0;
    }
  }

  .aa:hover {
    background-color: #33b281;
  }

</style>



// WEBPACK FOOTER //
// src/components/AppCabecalho.vue